import { render, staticRenderFns } from "./NotesTab.vue?vue&type=template&id=1f797e1a&scoped=true&"
import script from "./NotesTab.vue?vue&type=script&lang=js&"
export * from "./NotesTab.vue?vue&type=script&lang=js&"
import style0 from "./NotesTab.vue?vue&type=style&index=0&id=1f797e1a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f797e1a",
  null
  
)

export default component.exports